<template>
  <div>
    <van-nav-bar
      title="电子发票"
      left-arrow
      @click-left="back"
      style="font-size: 12px;color: #333333;"
    />
    <div class="invoice-container">
      <div class="invoice-header">
        火车票电子发票
      </div>
      <div class="invoice-content">
        <van-cell-group>
          <van-field
            v-model="selectInvoiceHeader.title"
            label="发票抬头"
            placeholder="请输入发票抬头"
            readonly
          />
          <van-field
            v-model="selectInvoiceHeader.taxNumber"
            label="发票税号"
            placeholder="请输入发票税号"
            readonly
          />
        </van-cell-group>

        <van-button type="info" block @click="openInvoiceHeader">
          发票抬头管理
        </van-button>
      </div>
      <div class="invoice-open">
        <van-button type="info" block @click="openInvoicePopup">
          开具电子发票
        </van-button>
      </div>

      <div class="invoice-notice">
        <div class="notice-title">
          业务须知
        </div>
        <div class="notice-content">
          <p>1. 按照《国家税务总局财政部 中国国家铁路集团有限公司关于铁路客运推广使用全面数字化的电子发票的公告》（2024年第8号）要求，铁路旅客运输领域推广使用电子发票（铁路电子发票），旅客需报销入账时，可通过铁路12306（包括网站和移动客户端）取得本人的电子发票（铁路电子发票）。</p>
          <p>2. 电子发票（铁路电子发票）属于全面数字化的电子发票，与纸质增值税发票具有同等法律效力，可作为报销入账和税务抵扣的合法凭证。</p>
          <p>3. 铁路运输企业对通过铁路客票发售和预订系统办理境内旅客运输售票、退票、改签业务并支付费用的，提供开具电子发票（铁路电子发票）服务，但办理跨境旅客运输和境内尚未实施铁路电子发票的旅客运输业务时，暂不提供开具电子发票（铁路电子发票）服务。</p>
          <p>4. 自2024年11月1日起，车票乘车日期为2024年11月1日及之后的旅客，在行程结束或支付退票、改签费用后，可于180天内登录铁路12306账户，如实取得本人的电子发票（铁路电子发票）。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {NavBar, CellGroup, Field, Button, Toast, Dialog} from 'vant';
import {mapGetters, mapState} from "vuex";

export default {
  name: 'TrainsInvoice',
  components: {
    [NavBar.name]: NavBar,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Button.name]: Button,
  },
  data() {
    return {
      invoiceTitle: '中国****有限公司',
      taxNumber: '9000********3456',
    };
  },
  created() {
    this.showAuthorizeDialog()
  },
  computed: {
    ...mapGetters({
      selectInvoiceHeader: 'invoice/selectInvoiceHeader',
      userInfo: 'userInfo'
    }),
    ...mapState({
      loginConfig: state => state.app.loginConfig,
      trSearchInfo: state => state.tr.trSearchInfo,
      travelerList: state => state.tr.travelerList
    })
  },
  methods: {
    back() {
      this.$router.push({path: '/userCenter/billInvoice'});
    },
    openInvoicePopup() {
      // 打开开具电子发票的弹窗逻辑
      this.showAuthorizeDialog()
      var isLoginSucccess = this.trSearchInfo['12306Info'].isLoginSucccess
      if (isLoginSucccess) {
        this.$router.push('/userCenter/billInvoice/trainsInvoice/openInvoiceList')
      }
    },
    openInvoiceHeader() {
      // 打开开具电子发票抬头的弹窗逻辑
      this.showAuthorizeDialog()
      var isLoginSucccess = this.trSearchInfo['12306Info'].isLoginSucccess
      if (isLoginSucccess) {
        this.$router.push('/userCenter/billInvoice/trainsInvoice/invoiceManagement')
      }
    },
    showAuthorizeDialog() {

      console.log("userInfo{}",this.userInfo)

      var isLoginSucccess = this.trSearchInfo['12306Info'].isLoginSucccess

      if (!isLoginSucccess){
        Toast.fail("授权失败，请先进行12306登录！");
        Dialog.confirm({
          title: '12306授权',
          message: '发票相关需要12306授权操作',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonColor: '#07c160',
          cancelButtonColor: '#ee0a24',
        })
          .then(() => {
            this.$router.push('/userCenter/billInvoice/login/theLogin12306');
          })
          .catch(() => {
            // 用户点击取消按钮
            Toast.fail("取消授权！");
            // 在这里执行取消后的操作
          });
      }
    }
  },
  mounted() {
    // 初始化加载数据
    this.invoiceList = this.allInvoiceList;
    // 从 Vuex 中获取 selectedInvoice 并初始化选择框的状态
    console.log("this.trSearchInfo{}",this.trSearchInfo)

    this.showAuthorizeDialog()
  },
};
</script>

<style lang="less" scoped>
.invoice-container {
  padding: 16px;
  background-color: #fff;
}

.invoice-header {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
}

.invoice-content {
  margin-bottom: 24px;
}

.invoice-notice {
  .notice-title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .notice-content {
    font-size: 12px;
    color: #666;
    line-height: 1.5;

    p {
      margin-bottom: 8px;
    }
  }
}
</style>
